import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';
const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getSalesSummary = async (branchId, startDate, endDate, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/reports/sales-summary`, {
    ...withAuth(),
    params: { startDate, endDate, ...params },
  })).data;

export const getSalesBreakdown = async (
  branchId,
  startDate,
  endDate,
  groupBy,
  params = {}
) =>
  (await axios.get(`${API_URL}/branch/${branchId}/reports/sales-breakdown`, {
    ...withAuth(),
    params: { startDate, endDate, groupBy, ...params },
  })).data;
